module.exports = __webpack_public_path__ + "media/images/social-media/x_grey-b0b67c824c27ec92e4f813b0778b68e8.svg";